<template>
    <div class="notice content-continer ">
        <div class="base-content titles">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{content.newsTitle}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="base-content content">
            <h1 class="center">{{content.newsTitle}}</h1>
            <div style="text-align: right;color: #808080;font-size: 12px;margin-bottom: 20px; padding-right: 200px;">{{content.updateTime}}
            </div>
            <div v-html="content.newsContent" style="min-height:740px;">
            </div>
        </div>
    </div>
</template>

<script>
    import { gethomeMsg } from '@/request/api'
    export default {
        name: "notice",
        data() {
            return {
                content: '',
                id: ''
            };
        },
        methods: {
            // 鼠标移入加入class
            changeActive($event) {
                $event.currentTarget.className = "list-active";
            },
            removeActive($event) {
                $event.currentTarget.className = "";
            }
        },
        mounted() {
            this.id = this.$route.params.id;
            gethomeMsg(this.id).then((res) => {
                this.content = res.data.data;

            }).catch((err) => {
                console.log(err)
            })
        },
        beforeCreate() {
            document.querySelector('body').setAttribute('style', 'background-color:#F5F5F5;')
        },
        //销毁前清除
        beforeDestroy() {
            document.querySelector('body').removeAttribute('style')
        }
    };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    *{
        line-height:30px;
    }
    h1 {
        margin-bottom: 20px;
        margin-top: 50px;
        font-size: 20px;
       
    }

    .base-content>>>img {
        max-width: 1000px;
        margin: 0 auto;
        margin-top: 20px;
        margin-bottom: 20px;
    }
    .titles{
        margin-bottom: 20px;
        border-radius: 4px;
        margin-top: 20px;
    }
    .content{
        margin-bottom: 50px;
    }
</style>


// WEBPACK FOOTER //
// src/components/msg.vue